import { useQuery } from "@tanstack/react-query";
import { History, MapIcon, MapPin, Search } from "lucide-react";
import { getAdminLoginHistory } from "../../../services/admin/loginHistoryService";
import Loader from "../../../components/loader/loader";
import { Button } from "../../../components/ui/button";
import { useEffect, useState } from "react";

function AdminLoginHistory() {
  const [currentPage, setCurrentPage] = useState(1);
  // const [searchInput, setSearchInput] = useState(null);
  const today = new Date().toISOString().split("T")[0];
  const [fromDate, setFromDate] = useState(today);
  const [limit, setLimit] = useState(10);
  const [originalHistory, setOriginalHistory] = useState([]);
  const [history, setHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [refetch, setRefetch] = useState(false);

  const [toDate, setToDate] = useState(today);

  const formatDate = (date) => new Date(date).toLocaleString();

  const getDuration = (login, logout) => {
    if (!logout) return "Active";
    const diff = new Date(logout) - new Date(login);
    const minutes = Math.floor(diff / 60000);
    return `${minutes} min`;
  };

  const getBrowserName = (ua) => {
    if (!ua) return "-";
    if (ua.includes("Chrome")) return "Chrome";
    if (ua.includes("Firefox")) return "Firefox";
    if (ua.includes("Safari")) return "Safari";
    if (ua.includes("Postman")) return "Postman";
    return "Unknown";
  };

  const openInGoogleMaps = (lat, lng) => {
    if (!lat || !lng) return;
    const url = `https://www.google.com/maps?q=${lat},${lng}`;
    window.open(url, "_blank");
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();

    if (!value) {
      setHistory(originalHistory);
      return;
    }

    const filtered = originalHistory?.filter(
      (item) =>
        item.user_id?.toLowerCase().includes(value) ||
        item.name?.toLowerCase().includes(value),
    );

    setHistory(filtered);
  };
  const fetchHistory = async () => {
    setIsLoading(true);
    try {
      const res = await getAdminLoginHistory({
        fromDate,
        toDate,
        page: currentPage,
        limit,
      });

      if (res) {
        setOriginalHistory(res.data.data);
        setHistory(res.data.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();

    if (refetch) {
      setTimeout(() => {
        setRefetch(false);
      }, 500);
    }
  }, [refetch, currentPage, limit, fromDate, toDate]);

  return (
    <div className="">
      {isLoading && <Loader />}

      <div className="flex items-center gap-2 mb-6">
        <History size={22} className="text-blue-600" />
        <h1 className="text-xl font-semibold text-gray-800">Login History</h1>
      </div>

      <div className="w-full bg-white border border-slate-200 rounded-xl p-4 shadow-sm mb-6">
        <div className="flex flex-col lg:flex-row  justify-between gap-4">
          {/* From Date */}
          <div className="flex flex-col md:flex-row items-end  gap-4">
            {" "}
            <div className="flex flex-col w-full lg:w-auto">
              <label className="text-sm font-semibold text-slate-700 mb-1">
                From Date
              </label>
              <input
                className="px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                type="date"
              />
            </div>
            {/* To Date */}
            <div className="flex flex-col w-full lg:w-auto">
              <label className="text-sm font-semibold text-slate-700 mb-1">
                To Date
              </label>
              <input
                className="px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                type="date"
              />
            </div>
            {/*Total Records */}
            <div className="flex flex-col w-full lg:w-auto">
              <label className="text-sm font-semibold text-slate-700 mb-1">
                Record Limit
              </label>
              <select
                name=""
                id=""
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
                className="px-3 w-full min-w-[150px] py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            {/* Get History Button */}
            {/* <div className="w-full lg:w-auto">
              <Button
                variant="admin.secondary"
                className="w-full lg:w-auto h-[38px]"
                onClick={() => setRefetch(true)}
              >
                Get History
              </Button>
            </div> */}
          </div>

          {/* Search Section */}
          <div className="flex flex-col sm:flex-row items-start sm:items-end gap-2 w-fit ">
            <div className="flex flex-col w-full">
              <label className="text-sm flex items-center gap-2 font-semibold text-slate-700 mb-1">
                <Search size={14}/>                Search User Id

              </label>
              <input
                className="px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                // value={searchInput}
                onChange={handleSearch}
                type="search"
                placeholder="DOCT-00003"
              />
            </div>

           
          </div>
        </div>
      </div>

      <div className="overflow-x-auto bg-white rounded-2xl shadow-sm border">
        <table className="min-w-full text-sm text-left">
          <thead className="bg-gradient-to-r from-indigo-600 to-blue-600 text-white">
            <tr>
              <th className="px-4 py-3 font-medium">Name</th>
              <th className="px-4 py-3 font-medium">User Id</th>

              <th className="px-4 py-3 font-medium">Status</th>
              <th className="px-4 py-3 font-medium">Browser</th>
              <th className="px-4 py-3 font-medium">IP Address</th>
              <th className="px-4 py-3 font-medium">Login Time</th>
              <th className="px-4 py-3 font-medium">Logout Time</th>
              <th className="px-4 py-3 font-medium">Duration</th>
              <th className="px-4 py-3 font-medium">Location</th>
            </tr>
          </thead>

          <tbody className="divide-y">
            {history?.data?.length === 0 && (
              <tr>
                <td colSpan="7" className="text-center py-6 text-gray-500">
                  No login history found
                </td>
              </tr>
            )}

            {history?.map((session) => (
              <tr
                key={session.id}
                className={`hover:bg-gray-50 transition ${
                  session.is_active ? "bg-green-50/40" : ""
                }`}
              >
                <td className="px-4 py-3">{session.name}</td>
                <td className="px-4 py-3">{session.user_id || "_"}</td>
                {/* Status */}
                <td className="px-4 py-3">
                  {session.is_active ? (
                    <span className="px-3 py-1 text-xs font-medium bg-green-100 text-green-700 rounded-full">
                      Active
                    </span>
                  ) : (
                    <span className="px-3 py-1 text-xs font-medium text-nowrap bg-red-100 text-gray-600 rounded-full">
                      Logged Out
                    </span>
                  )}
                </td>

                {/* Browser */}
                <td className="px-4 py-3">
                  {getBrowserName(session.browser_name)}
                </td>

                {/* IP */}
                <td className="px-4 py-3">{session.ip_address || "-"}</td>

                {/* Login */}
                <td className="px-4 py-3">{formatDate(session.login_at)}</td>

                {/* Logout */}
                <td className="px-4 py-3">
                  {session.logout_at
                    ? formatDate(session.logout_at)
                    : "Still Active"}
                </td>

                {/* Duration */}
                <td className="px-4 py-3">
                  {getDuration(session.login_at, session.logout_at)}
                </td>

                {/* Location */}
                <td className="px-4 flex justify-center ">
                  {session.latitude && session.longitude ? (
                    <button
                      type="button"
                      onClick={() =>
                        openInGoogleMaps(session?.latitude, session.longitude)
                      }
                      className="p-3"
                    >
                      <MapPin size={22} />
                    </button>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {history?.totalPages > 1 && (
          <div className="flex justify-center gap-4 pt-4 border-t ">
            <Button
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
              variant="admin.secondary"
            >
              Prev
            </Button>

            <span className="text-sm mt-2">
              Page {currentPage} of {history?.totalPages}
            </span>

            <Button
              onClick={() =>
                setCurrentPage((p) => Math.min(p + 1, history?.totalPages))
              }
              disabled={currentPage === history?.totalPages}
              variant="admin.secondary"
            >
              Next
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminLoginHistory;
